// GOOGLE TAG MANAGER for general page impressions
import {setGtmContext, pushToDataLayer} from '@/js/global/helpers/gtm';

// EVENTS
/** @type {string} */
export const CONTACT_FORM_SUBMIT_EVENT = 'cf.submit';

export const GtmSiteMixin = {
   created() {
      setGtmContext();
   },
   methods: {

      // CONTACT FORM
      // ===========================================================================================

      /**
       * When the contact form is successfully submitted.
       *
       * @param data {object}
       */
      gtmContactFormSubmit(data) {
         if (data && Object.keys(data).length) {
            pushToDataLayer({event: CONTACT_FORM_SUBMIT_EVENT, contactForm: data});
         }
      },
   },
}